// src/lib/localDate.ts
//
// Dates as the person sees them in their browser. `toISOString()` gives the UTC
// date, which after local midnight is still «yesterday» — a default «Hasta»
// built from it left out today.

const pad = (n: number): string => String(n).padStart(2, '0');

/** YYYY-MM-DD of the browser's local calendar day. */
export const localIsoDate = (date: Date = new Date()): string =>
  `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

/** YYYY-MM-DD of the local day `days` days before today. */
export const localIsoDateDaysAgo = (days: number, now: Date = new Date()): string => {
  const d = new Date(now.getFullYear(), now.getMonth(), now.getDate() - days);
  return localIsoDate(d);
};

/**
 * A value typed in a local date or date-time control ("YYYY-MM-DD" or
 * "YYYY-MM-DDTHH:mm") as the UTC instant it means, in ISO form. A bare date as
 * an end bound means the end of that local day.
 */
export const localInputToUtcIso = (value: string, endOfDay = false): string | undefined => {
  if (!value) return undefined;
  const dateOnly = /^\d{4}-\d{2}-\d{2}$/.test(value);
  const local = dateOnly ? new Date(`${value}T${endOfDay ? '23:59:59.999' : '00:00:00'}`) : new Date(value);
  return Number.isNaN(local.getTime()) ? undefined : local.toISOString();
};
